import React from 'react'
import './index.css'

class Navigator extends React.Component {

    render() {
        return (
            <div className="navigator">
                <div className="navigator-container">
                    <div className="navigator-left">
                        <a href="javascript:void(0);">
                            <div className="navigator-left-bg1"></div>
                        </a>
                        <a href="javascript:void(0);">
                            <div className="navigator-left-bg2"></div>
                        </a>
                        <a href="javascript:void(0);">
                            <div className="navigator-left-bg3"></div>
                        </a>
                        <a href="javascript:void(0);">
                            <div className="navigator-left-bg4"></div>
                        </a>
                    </div>

                    <div className="navigator-right">
                        <a href="javascript:void(0);">
                            <div className="navigator-right-client">
                                <div className="navigator-right-client-icon"></div>
                                <p>客户端下载</p>
                            </div>
                        </a>
                        <div className="navigator-right-mobile">
                            <div className="navigator-right-mobile-qr"></div>
                            <p>手机端下载</p>
                        </div>
                        <div className="navigator-right-wx">
                            <div className="navigator-right-wx-qr"></div>
                            <p>微信公众号</p>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}

export default Navigator